var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"max-width"},[_c('web-editor',{staticClass:"hidden-sm-and-down",attrs:{"docCreate":_vm.docCreate,"copyStatus":_vm.copyStatus,"initial":_vm.dataItem},on:{"data":_vm.save}}),_c('snackbar',{ref:"snackbar"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }